




















import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import OwnerContact from './OwnerContact.vue';
import RecipientList from './RecipientList.vue';
import RoomIntro from './RoomIntro.vue';

export default defineComponent({
  name: 'Home',
  components: {
    OwnerContact,
    RecipientList,
    RoomIntro,
  },
  props: {
    recipients: {
      type: Array as PropType<Recipient[]>,
      default: () => [],
    },
    drName: {
      type: String,
      required: true,
    },
    owner: {
      type: Object as PropType<User>,
      required: true,
    },
    editable: {
      type: Boolean,
    },
  },
});
